/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { withDefault } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

// required attributes
const FtpServerR = t.interface({
  host: t.string,

  enabled: withDefault(t.boolean, true),

  password: t.string,

  port: t.Integer,

  root_path: t.string,

  service: t.string,

  type: t.string,

  username: t.string
});

// optional attributes
const FtpServerO = t.partial({
  history_path: t.string,

  in_path: t.string,

  out_path: t.string
});

export const FtpServer = t.intersection([FtpServerR, FtpServerO], "FtpServer");

export type FtpServer = t.TypeOf<typeof FtpServer>;
